import React, { MouseEvent } from "react"

import { useLayerPopupContext } from "@shared/contexts"

export default function Setting() {
  const { open } = useLayerPopupContext()

  return (
    <React.Fragment>
      <li className="ty04">
        <a
          href="#!"
          title="환경설정"
          onClick={(e: MouseEvent) => {
            e.preventDefault()
            open("SETTING")
          }}
        >
          <i>-</i>환경설정
        </a>
      </li>
    </React.Fragment>
  )
}
